export default function () {
  return [
    {
      type: 'DatePicker',
      title: '提交时间',
      [$field]: 'adviceTime',
      rules: [''],
      colSpan: 8,
      readOnly: true
    },
    {
      type: 'Input',
      title: '标题',
      [$field]: 'title',
      rules: [''],
      colSpan: 24,
      placeholder: '请输入'
    },
    {
      type: 'Checkbox',
      title: '心声建议类型',
      [$field]: 'typeCodes',
      colSpan: 8,
      optionList: this.getTypeCodesOptionList,
      rules: ['required']
    },
    {
      type: 'Input',
      title: '其他类型描述',
      [$field]: 'otherTypeDesc',
      rules: [''],
    },
    {
      type: 'Input',
      title: '所属组织',
      [$field]: 'orgName',
      rules: ['required'],
      colSpan: 24,
      readOnly: true
    },
    {
      type: 'textarea',
      title: '心声建议说明',
      [$field]: 'adviceDesc',
      rules: ['required'],
      colSpan: 24,
      placeholder: '请输入'
    }
  ]
}
export const attachmentOptions = function () {
  return [
    {
      type: 'FileUpload',
      title: '附件资料',
      colSpan: 24,
      [$field]: 'fileInfo',
      readOnly: true,
      props: {
        data: {
          groupId: ''
        },
        multiple: true,
        isShowFileList: true
      },
      rules: ['required']
    }
  ]
}


export const theSecondAttachmentOptions = function () {
  return [
    {
      type: 'Radio',
      title: '审核结果',
      colSpan: 6,
      [$field]: 'auditResult',
      rules: ['required'],
      optionList: [
        {
          label: '同意',
          value: 'agree'
        },
        {
          label: '拒绝',
          value: 'refuse'
        }
      ],
    },
    {
      type: 'textarea',
      title: '审核意见',
      colSpan: 24,
      [$field]: 'auditContent',
      rules: ['required']
    },
    {
      type: 'Input',
      title: '审核人',
      colSpan: 6,
      readOnly: true,
      [$field]: 'auditName',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '审核时间',
      colSpan: 6,
      readOnly: true,
      [$field]: 'auditTime',
      rules: ['']
    },
    {
      type: 'Input',
      title: '审核组织名称',
      colSpan: 6,
      readOnly: true,
      [$field]: 'auditOrgName',
      rules: ['']
    }
  ]
}